module.exports = __webpack_public_path__ + "static/img/h32.7308d01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h32.jpg
// module id = Y8FO
// module chunks = 0